import { render, staticRenderFns } from "./SentNotifications.vue?vue&type=template&id=4d613d75&scoped=true"
import script from "./SentNotifications.vue?vue&type=script&lang=js"
export * from "./SentNotifications.vue?vue&type=script&lang=js"
import style0 from "./SentNotifications.vue?vue&type=style&index=0&id=4d613d75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d613d75",
  null
  
)

export default component.exports